import { DOCUMENT } from '@angular/common';
import { ChangeDetectorRef, Component, DoCheck, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { ContractType } from '../../../shared/models/contract/contract-type.model';
import { CommonService } from '../../../shared/service/common.service';
import { ValidationUiService } from '../../../shared/service/ui/validation-ui';

@Component({
  selector: 'app-policy-calander',
  templateUrl: './policy-calander.component.html'
})
export class PolicyCalanderComponent implements OnInit, DoCheck {
  @Output() doCheck: EventEmitter<string> = new EventEmitter<string>();
  @Input() contractType: ContractType;
  private policyStartRealDate = '';

  constructor(
    private ref: ChangeDetectorRef,
    @Inject(DOCUMENT) private document: Document,
    public validationUiService: ValidationUiService,
    private commonService: CommonService
  ) {}

  ngOnInit(): void {
    // eslint-disable-next-line no-eval
    eval('calendar_module.init()');
    this.ref.detectChanges();
    (document.getElementById('txtCalendarPolicyDate') as HTMLInputElement).value = this.commonService.customDateFormat(this.contractType.policyStartRealDate, 'dd/MM/yyyy') ?? '';
  }

  ngDoCheck() {
    const date = (document.getElementById('txtCalendarPolicyDate') as HTMLInputElement).value;
    if (this.policyStartRealDate !== date) {
      this.policyStartRealDate = date ?? '';
      this.doCheck.emit(this.policyStartRealDate);
    }
  }
}
